"use strict";
exports.__esModule = true;
function default_1(s) {
    s = s.toLowerCase();
    if (s === '') {
        return false;
    }
    return !isNaN(Number(s)); // http://stackoverflow.com/a/175787
}
exports["default"] = default_1;
;
